import { Model } from '@vuex-orm/core'
import User from '@/store/models/User'

export default class VideoRoomMaster extends Model {
  static entity = 'videoRoomMasters'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      roomId: this.string(''),
      roomName: this.string(''),
      roomDescription: this.string(''),
      roomCapacity: this.number(0),
      roomType: this.string(''),
      meta: this.attr(null)
    }
  }

  inDuration() {
    return this.meta &&
           this.meta.latestRoomInfo &&
           this.meta.latestRoomInfo.inDuration
  }

  scheduled() {
    return this.meta &&
           this.meta.latestRoomInfo
  }

  getLatestRoomInfoUsers() {
    return this.scheduled() ? User.findIn(this.meta.latestRoomInfo.userIds).concat(this.meta.latestRoomInfo.temporaryGuestUserIds.map(() => {
      return {
        temporaryGuest: true
      }
    })) : []
  }

  getCurrentCafeInfoUsers() {
    return this.meta.currentCafeInfo ? User.findIn(this.meta.currentCafeInfo.userIds.filter((x, i, self) => {
        return self.indexOf(x) === i;
    })) : []
  }
}
